import graphql from "babel-plugin-relay/macro";
import styled from "styled-components";
import { useFragment } from "react-relay";
import { FieldDetailsAttributesFragment$key } from "./__generated__/FieldDetailsAttributesFragment.graphql";

interface FieldDetailsGeometryProps {
  fieldData: FieldDetailsAttributesFragment$key;
}

const FieldAttributes = ({ fieldData }: FieldDetailsGeometryProps) => {
  const field = useFragment(
    graphql`
      fragment FieldDetailsAttributesFragment on FieldNode {
        managementPackageSetting {
          enableWidth
        }
        registeredArea
        length
        width
        units
      }
    `,
    fieldData
  );
  return (
    <FieldDetailsContainer>
      <Title>Weergave gegevens</Title>
      <DetailsContainer>
        {[
          ["Oppervlakte", field.registeredArea, "ha"],
          ...(field?.width &&
          field.width > 0 &&
          field?.managementPackageSetting?.enableWidth
            ? [["Breedte", field.width || 0, "m"]]
            : []),
          ...(field?.length && field.length > 0
            ? [["Lengte", field.length || 0, "m"]]
            : []),
          ...(field?.units && field.units > 0
            ? [["Stuks", field.units, field.units! > 1 ? "stuks" : "stuk"]]
            : []),
        ]?.map(([title, value, unit], ix) => (
          <DetailRow key={`detailrow_${ix}`}>
            <DetailText>{title}</DetailText>
            <DetailValue>
              {value}&nbsp;{unit}
            </DetailValue>
          </DetailRow>
        ))}
      </DetailsContainer>
    </FieldDetailsContainer>
  );
};

const FieldDetailsContainer = styled.div`
  margin: 20px 0;
`;

const Title = styled.span`
  color: #000;
  font-family: Roboto;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  font-size: 10px;
  text-transform: uppercase;
`;

const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 260px;
`;

const DetailText = styled.span`
  color: var(--Donkergrijs, #212529);
  font-family: Roboto;
  font-style: normal;
  font-size: 12px;

  font-weight: 700;
  line-height: 120%;
`;

const DetailValue = styled.span`
  width: 100px;
  color: var(--Donkergrijs, #212529);

  /* Text small */
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;

  line-height: 120%; /* 14.4px */
`;

const DetailsContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export default FieldAttributes;
